import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { includes } from 'lodash';

import { LOG_EXCEPTIONS, SENTRY_DNS } from '@/constants';

import { parseError } from '@/api/request';

export const configureExceptionHandling = (errorHandler) => {
  if (LOG_EXCEPTIONS) {
    Sentry.init({
      dsn: SENTRY_DNS,
      integrations: [new Sentry.Integrations.Vue({ Vue })],
    });

    Vue.config.errorHandler = errorHandler;
  }
};

export const handleError = ({ commit }, mutationName = null, mutationParams = null, callback = null) => (error) => {
  const parsedError = parseError(error);

  if (mutationName) {
    if (includes(mutationName, '/')) {
      commit(mutationName, { ...mutationParams, error }, { root: true });
    } else {
      commit(mutationName, { ...mutationParams, error });
    }
  }
  if (callback) callback(parsedError);

  return { status: false, error: parsedError };
};

export const logException = (error) => {
  if (LOG_EXCEPTIONS) {
    Sentry.captureException(error);
  }
};



// WEBPACK FOOTER //
// ./src/utils/exception_handler.js